import { render, staticRenderFns } from "./InteriorDesignTabOne.vue?vue&type=template&id=210297bd"
var script = {}
import style0 from "./InteriorDesignTabOne.vue?vue&type=style&index=0&id=210297bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports